import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnPolicyTypeList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const PolicyTypeList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [policyTypeList, setPolicyTypeList] = useState([]);
  const [policyTypeListCount, setPolicyTypeListCount] = useState(0);
  const [policyTypeListPerPage, setPolicyTypeListPerPage] = useState(10);
  const [activePolicyTypeListPage, setActivePolicyTypeListPage] = useState(1);
  const [searchPolicyTypeListFilter, setSearchPolicyTypeListFilter] = useState("");
  const [columnPolicyTypeListSorter, setColumnPolicyTypeListSorter] = useState({ column: "updatedAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchPolicyTypeListFilter,
      limit: policyTypeListPerPage,
      offset: policyTypeListPerPage * activePolicyTypeListPage - policyTypeListPerPage,
      sort:
        (columnPolicyTypeListSorter &&
          `${columnPolicyTypeListSorter.column}%${columnPolicyTypeListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllPolicyTypes(queries);
  }, [
    searchPolicyTypeListFilter,
    policyTypeListPerPage,
    activePolicyTypeListPage,
    columnPolicyTypeListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActivePolicyTypeListPage(1)
    setSearchPolicyTypeListFilter(search);
  }

  const fetchAllPolicyTypes = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/policy-type?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let tempPolicyTypeList = data?.value
          setPolicyTypeList(tempPolicyTypeList);
          if (activePolicyTypeListPage === 1) {
            setPolicyTypeListCount(data?.count);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/policy-type/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllPolicyTypes()
          showSuccess('Policy type has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        let errorMessage = err?.response?.data?.message || 'Failed to delete the item.'
        if (errorMessage == 'policy-type-has-used') {
          showError('This policy type has been used in a company policy and cannot be deleted.')
        }
        setShowConfirmDelete({ show: false, item: {} })
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/policy-type/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={`Policy Type ${showConfirmDelete?.item?.name}`}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/policy-type/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Policy Type
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Policy Type List</h4>}
        bodyContent={
          <AppTable
            policyTypeListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnPolicyTypeList}
            tableContent={policyTypeList}
            contentPerPage={policyTypeListPerPage}
            activeContentPage={activePolicyTypeListPage}
            contentCount={policyTypeListCount}
            searchContentFilter={searchPolicyTypeListFilter}
            setActiveContentPage={setActivePolicyTypeListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setPolicyTypeListPerPage}
            setColumnContentSorter={setColumnPolicyTypeListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default PolicyTypeList